import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/** Combina classes condicionais (clsx) e resolve conflitos entre utilitários Tailwind (tailwind-merge). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}